var _circle, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5701,
    cy: 39.4409,
    r: 39.3266,
    fill: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_363_868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 75,
    height: 75
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.5702,
    cy: 37.4745,
    rx: 36.7048,
    ry: 37.3603,
    fill: "#959598"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_363_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8062 69.4007C68.4943 68.5716 48.9466 56.9649 48.9466 56.9649C46.2432 54.9959 45.8273 53.0269 48.1148 51.8869C49.9864 50.9543 51.65 47.8453 52.8977 44.5291C53.1057 44.6327 53.3137 44.6327 53.6256 44.5291C58.8244 42.9746 58.9284 32.6114 55.3932 34.4768C58.6165 6.28898 19.5212 6.28898 22.7445 34.4768C19.2093 32.6114 19.2093 43.0783 24.4081 44.5291C24.6161 44.6327 24.928 44.5291 25.136 44.5291C26.3837 47.8453 28.0473 50.9543 29.9189 51.8869C32.2064 53.0269 31.6865 54.8923 28.9831 57.0685C28.0473 57.794 15.4661 64.8409 11.9309 67.2244C10.4752 68.1571 9.43548 68.9862 9.22753 69.5043C8.18776 71.7842 7.77185 75.515 7.77185 75.515H70.1579C70.1579 75.515 69.742 71.7842 68.8062 69.4007Z",
    fill: "#A7A7A7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAvatar);
export default __webpack_public_path__ + "static/media/icon-user-avatar.6f445e9ad02944fc738f7fbe56fad80e.svg";
export { ForwardRef as ReactComponent };